import React, { memo, useEffect } from "react";
import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {ReactComponent as ButtonClose} from "../../../assets/kinologyIcons/svg/closeWhite.svg";
import { TextsProps } from "../../../database/txt.interface";
import { AppActions } from "../../../store/ducks/app";
import {ButtonAction, Container, ContainerConditions, Option,Dispensar, FooterContainer, OptionsContainer, Title} from './styles'
import { AmplitudeLog } from "../../../utils/amplitude";
import { Colors } from "../../../styles/colors";
import Text from '../../../components/Texts/Text';

import  Campanha from '../../../assets/kinologyIcons/png/Campanha_indique_ganhe.png';
import { persistStorage } from "../../../utils/base_async_storage";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

const ModalPromo: React.FC = () => {
	const dispatch = useDispatch();

	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);


	const classes = useStyles();

	const ModalCadastroClose = () => {
		dispatch(AppActions.set_modal_adicionar_anotacao(false));
	};

	useEffect(()=>{
		AmplitudeLog('modal_embaixador_viu')
		
	},[])

	const SaveLastShown = ()=> {
		persistStorage({
			res: moment().format('DD-MM-YYYY'),
			tag: 'modalPromo',
		})
	};

	const modalVisible: boolean = useSelector((state: any) => state.app.modal_promo_visible);

	const conditions = [
		{title: current_language?.cadastrar_embaixador, width:'50%'},
		{title: current_language?.indique_profissionais,  width:'50%'},
		{title: current_language?.receba_por_cliente_indicado,  width:'35%'},
	];


	return (
		<div>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={modalVisible}
				onClose={ModalCadastroClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={modalVisible}>
					<Container>
							<ButtonClose 
								className="close" color={Colors.neutral_grey_k_5} 
								onClick={()=>{
									dispatch(AppActions.set_modal_promo(false))
									AmplitudeLog('modal_embaixador_saiu')
									SaveLastShown()
								}}	
							/>
							<Title color={Colors.neutral_grey_k_5}>
									{current_language?.ganhe} <Title color={Colors.secondary_green_k_main}>{current_language?.valor_indicacao}</Title>{' ' + current_language?.indicacao_confirmada}
							</Title>
							<ContainerConditions>
								{
									conditions.map((item, key)=>(
										<OptionsContainer key={key}>
											<Option style={{marginRight:5}}>
												{'•'}
											</Option>
											<Option width={item.width}>
												{item.title}
											</Option>
										</OptionsContainer>
									))
								}
							</ContainerConditions>
						
						
							<img 
								src={Campanha}
								className="image"
								style={{
									position: 'absolute',
									bottom: 0 ,
									right: 0 ,
									borderBottomRightRadius:30,
								}}
							/>
							<FooterContainer >
								<ButtonAction onClick={()=> {
										window.open('https://kinology.com.br/embaixadores-kinology/?bl_ref=2X1JM', "_blank")
										dispatch(AppActions.set_modal_promo(false))
										AmplitudeLog('modal_embaixador_clicou')
										SaveLastShown()
									}}
								>
									<Text 
										title={current_language?.seja_embaixador}
										fontFamily='Kanit-Regular'
										fontSize={1.3}
										fontWeight={700}
										textColor={Colors?.primary_blue_k_main}
										cursor="pointer"
									/>
								</ButtonAction>
							
								<Dispensar onClick={()=>{
									  dispatch(AppActions.set_modal_promo(false))
						 				AmplitudeLog('modal_embaixador_saiu')
										SaveLastShown()
									}}
								>
									{current_language?.dispensar}
								</Dispensar> 
						
							</FooterContainer>
					</Container>
				</Fade>
			</Modal>
		</div>
	);
};

export default memo(ModalPromo);
